<template>
    <div>
        <v-dialog
            v-model="dialog"
            overlay-color="white"
            width="800px">
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind="attrs"
                    v-on="on"
                    class="list-tooltip"
                    style="vertical-align: text-bottom; display: inline">
                    <slot name="modal-trigger"></slot>
                </div>
            </template>
            <v-form>
                <v-card>
                    <v-card-title>{{ title }}</v-card-title>
                    <v-card-text>Change account name
                        <v-text-field label="Account Name" single-line v-model="form.company_name">
                            {{ form.company_name }}
                        </v-text-field>
                        <v-row>
                            <v-col class="text-center mt-12">
                                <v-btn color="primary" depressed rounded height="48" width="300" @click="save">
                                    <span v-if="!isLoading">Save</span><span v-else>Saving...</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        account: {
            type: Object,
            required: true
        },
        thisKey: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            form: new Form({
                id: this.account.id,
                household_id: this.account.household_id,
                company_name: this.account.company_name,
                type_of_account_cd: this.account.type_of_account_cd,
                value: this.account.value,
                account_number: this.account.account_number ? this.account.account_number : null,
                annuity_value: this.account.annuity_value,
                beneficiary_id: this.account.beneficiary_id ? this.account.beneficiary_id : null,
                emergency_funds: this.account.emergency_funds,
                has_income_rider: this.account.has_income_rider,
                individual_id: this.account.individual_id,
                is_annuity: this.account.is_annuity,
                notes: this.account.notes ? this.account.notes : null,
                owner: this.account.owner,
            }),
            isLoading: false,
            dialog: false,
        }
    },
    methods: {
        save() {
            if (this.form.company_name) {
                this.isLoading = true;

                this.form.put('/api/household/' + this.account.household_id + '/iav-accounts/' + this.account.id, { showLoader: false })
                    .then(() => this.postSave())
                    .catch(() => this.isLoading = false);
            }
        },
        postSave() {
            this.$emit('updateName', {company_name: this.form.company_name, index: this.thisKey});
            this.isLoading = false;
            this.dialog = false;
        },
    }
}
</script>
